import React from 'react'
import PropTypes from 'prop-types'
import Image from 'react-image'
import Modal from 'components/shared/modal/wide'
import GalleryLoader from 'components/shared/loaders/gallery'
import Divider from 'components/shared/divider/vertical'
import NoImage from 'assets/images/no-image.jpg'
import BuildingIcon from 'components/shared/icons/building'
import BodyClass from 'components/shared/body-class'

const VenueGallery = ({ images, toggle, title, address }) => (
  <Modal className="modal-container-gallery bg-white w-full mx-auto rounded shadow-lg z-50 h-screen overflow-auto">
    <BodyClass className="modal-open gallery-modal" />
    <div className="sticky top-0 bg-white">
      <div className="modal-header flex flex-row text-left px-6 py-8">
        <div className="modal-close cursor-pointer z-50 p-3 text-primary-lightgray" onClick={toggle}>
          <i className="fa fa-arrow-left fa-lg" aria-hidden="true" />
        </div>
        <div className="py-2 px-10">
          <Divider />
        </div>
        <div className="lato-reg text-primary-lightgray">
          <p className="text-sm lg:text-xl">{title}</p>
          <p className="text-xs lg:text-base text-primary-lightgray flex items-center relative pl-6">
            <BuildingIcon /> {address}
          </p>
        </div>
      </div>
    </div>
    <div className="px-6 py-10 flex flex-col items-center">
      {images.map((image, key) => (
        <div className="image-container my-5 rounded" key={key}>
          <a rel="noreferrer" target="_blank" href={image.src || NoImage}>
            <Image
              className="rounded-lg"
              src={[image.src, NoImage]}
              alt={image.alt}
              loader={<GalleryLoader className={key === 0 ? 'primary' : ''} />}
            />
          </a>
        </div>
      ))}
    </div>
  </Modal>
)

VenueGallery.propTypes = {
  toggle: PropTypes.func,
  images: PropTypes.object,
  title: PropTypes.string,
  address: PropTypes.string,
}

export default VenueGallery
